import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/utils.js';
const variantStyles = {
    default: 'bg-gray-100 text-gray-800',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
    danger: 'bg-red-100 text-red-800',
    info: 'bg-blue-100 text-blue-800',
};
export function Badge({ className, variant = 'default', ...props }) {
    return (_jsx("span", { className: cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold', variantStyles[variant], className), ...props }));
}
//# sourceMappingURL=Badge.js.map